var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-border-l"},[_c('router-link',{staticClass:"btn btn-icon gl-mx-3 gl-border-0 gl-px-3",attrs:{"to":{
      name: _vm.$options.ROUTES.workItem,
      query: _vm.$route.query,
    },"aria-label":_vm.s__('DesignManagement|Go back to designs')}},[_c('gl-icon',{attrs:{"name":"close"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }